export default [
  {
    path: '/progressIndex',
    component: () =>
      import('../pages/merchantsManage/registerProgress/progressIndex.vue'),
    name: 'progressIndex',
    title: '入驻流程',
    meta: {
      title: '入驻流程',
    },
  },
]
